import { Component, OnInit } from "@angular/core";

import { Observable, Subject } from "rxjs";
import { first, map, shareReplay } from "rxjs/operators";

import { DffRouteParams } from "@dffedb/router";

import { DokumentService } from "../shared/dokument.service";

@Component({
    selector: "dokument",
    templateUrl: "./dokument.component.html",
    styleUrls: ["./dokument.component.scss"]
})
export class DokumentComponent implements OnInit {
    public dataLoaded$ = new Subject<void>();
    public sideTitel$: Observable<string>;
    public pdfUrls$: Observable<string[]>;

    constructor(private readonly routeParams: DffRouteParams, private readonly service: DokumentService) {}

    public ngOnInit(): void {
        const dokumentId = parseInt(this.routeParams.get("id"), 10);
        this.sideTitel$ = this.service.hentUmbracoIndstillinger().pipe(map((i) => i.sideTitel));
        this.pdfUrls$ = this.service.hentDokumentUrler(dokumentId).pipe(first(), shareReplay(1));
        this.pdfUrls$.subscribe({
            error: (error) => this.dataLoaded$.error(error)
        });
    }
    public addMissingLabel() {
        const findInputMultiline = document.getElementById("findInputMultiline") as HTMLTextAreaElement;
        const errorMoreInfo = document.getElementById("errorMoreInfo") as HTMLTextAreaElement;
        const fileInput = document.getElementById("fileInput") as HTMLInputElement;

        if (findInputMultiline) {
            findInputMultiline.setAttribute("aria-label", "Find linje i dokumentet. Flere linjer kan søges ved at trykke på Enter.");
        }
        if (errorMoreInfo) {
            errorMoreInfo.setAttribute("aria-label", "Fejlbesked.");
        }
        if (fileInput) {
            fileInput.setAttribute("aria-label", "Vælg fil");
        }
    }

    public onDataLoaded(): void {
        this.dataLoaded$.next();
        setTimeout(() => {
            this.addMissingLabel();
        }, 500);
    }
}
